/**
 * What the document preview fetches and how it types the bytes. The file sits behind the login,
 * so the preview fetches it into a blob and shows it from an object URL; the files route answers
 * every file as `application/octet-stream`, so the blob is typed here. Pure.
 */
import { asPlayable, isAudioFileType } from '@/utils/audio-playback'

/**
 * Where the preview fetches the document. An audio file is asked for as its playback copy: a
 * recording made in a browser carries no duration and no seek index, so its job stores a copy
 * every browser plays and seeks in. A document without one answers with the file itself.
 */
export function previewDownloadPath(
  caseId: string,
  documentId: string,
  fileType: string | null
): string {
  const path = `/api/v1/cases/${caseId}/documents/${documentId}/download`
  return isAudioFileType(fileType) ? `${path}?variant=playback` : path
}

/**
 * The fetched bytes as the preview shows them. `answeredBy` is the URL the bytes came from after
 * the redirect: an audio file is typed by it, since a recording's playback copy is another
 * container than the recording.
 */
export function previewBlob(blob: Blob, fileType: string | null, answeredBy: string): Blob {
  if (fileType === 'pdf') {
    return blob.type === 'application/pdf' ? blob : new Blob([blob], { type: 'application/pdf' })
  }
  return isAudioFileType(fileType) ? asPlayable(blob, answeredBy) : blob
}
